import React from 'react';

const Impact = () => {
    return (
        <div className="fun-facts">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="left-content">
                            <span>Our Impact</span>
                            <h2>Building Tomorrow's <em>Tech Leaders</em></h2>
                            <p>Through our workshops, competitions, and community projects, Creative Lab ISI has created a lasting impact on the tech community. We've trained hundreds of students, organized successful events, and made meaningful contributions to society through our service initiatives.</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="count-area-content">
                                    <div className="count-digit">300</div>
                                    <div className="count-title">Students Trained</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="count-area-content">
                                    <div className="count-digit">50</div>
                                    <div className="count-title">Workshops Organized</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="count-area-content">
                                    <div className="count-digit">20</div>
                                    <div className="count-title">Community Projects</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="count-area-content">
                                    <div className="count-digit">535</div>
                                    <div className="count-title">Social Media Followers</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Impact;